export enum OrderStatus {
  ENTRY = "ENTRY",
  QUOTING = "QUOTING",
  REVIEW = "REVIEW",
  CONFIRMING = "CONFIRMING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  ERROR = "ERROR",
}
